import { TableCell, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

interface NoResultsTableRowProps {
  noResultText?: string;
  colSpan?: number;
}

const NoResultsTableRow: FC<NoResultsTableRowProps> = ({ noResultText = 'utils.table.no_results', colSpan = 25 }) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Typography variant='h3' align='center'>
          {t(noResultText)}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default NoResultsTableRow;
